import { Grid, Paper, Stack } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { showUsaFeature } from 'utils/app';
import { PatientHealthInfo } from './PatientHealthlnfo';
import { PatientPersonalInfo } from './PatientPersonalInfo';
import { PatientQuestionnaire } from './PatientQuestionnaire';

export const PatientInfo = () => {
  const { patientId } = useParams<{ patientId: string; tab: string }>();

  return (
    <Grid gutter={'lg'}>
      <Grid.Col span={showUsaFeature ? 12 : 6}>
        <Stack>
          <Paper shadow={'sm'} radius={'md'} p={'md'} withBorder>
            <PatientPersonalInfo patientId={patientId} />
          </Paper>
          <Paper shadow={'sm'} radius={'md'} p={'md'} withBorder>
            <PatientHealthInfo patientId={patientId} />
          </Paper>
        </Stack>
      </Grid.Col>
      {!showUsaFeature && (
        <Grid.Col span={6}>
          <Paper shadow={'sm'} radius={'md'} p={'md'} withBorder>
            <PatientQuestionnaire patientId={patientId} />
          </Paper>
        </Grid.Col>
      )}
    </Grid>
  );
};
